import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WordmarkProps {
    className?: string
    size?: 'sm' | 'md' | 'lg'
}

/** The Serene Corpse wordmark: the two worlds joined by a crescent moon. */
export const Wordmark: FC<WordmarkProps> = ({ className, size = 'md' }): ReactNode => {
    const text = size === 'sm' ? 'text-[0.72rem] tracking-[0.34em]' : size === 'lg' ? 'text-xl tracking-[0.38em]' : 'text-[0.8rem] tracking-[0.36em] sm:text-[0.86rem]'
    const icon = size === 'sm' ? 'size-3' : size === 'lg' ? 'size-5' : 'size-3.5'

    return (
        <span className={cn('inline-flex items-center gap-[0.55em] font-brand font-medium uppercase text-ivory', text, className)}>
            <span>Serene</span>

            <svg viewBox='0 0 24 24' className={cn(icon, 'text-gold')} aria-hidden='true' focusable='false'>
                <path d='M15.5 3.2a9 9 0 1 0 5.3 12.9A7.4 7.4 0 0 1 15.5 3.2Z' fill='currentColor' />
            </svg>

            <span className='-mr-[0.36em]'>Corpse</span>
        </span>
    )
}

export const MoonMark: FC<{ className?: string }> = ({ className }): ReactNode => (
    <svg viewBox='0 0 24 24' className={className} aria-hidden='true' focusable='false'>
        <path d='M15.5 3.2a9 9 0 1 0 5.3 12.9A7.4 7.4 0 0 1 15.5 3.2Z' fill='currentColor' />
    </svg>
)
